
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/best-hospital/[...slug]",
      function () {
        return require("private-next-pages/best-hospital/[...slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/best-hospital/[...slug]"])
      });
    }
  